import React, { useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import VideoPlayerModal from '../../common/VideoPlayerModal';


const VirtualWorlds = () => {
    const [modalShow, setModalShow] = useState(false);
    const [videoUrl, setVideoUrl] = useState(null)

    const openVideoModal = (data) => {
        setModalShow(true)
        setVideoUrl(data)

    }
  return (
    <>
         <Card className='text-center no-border rounded-0 container virtual-worlds-container pb-md-5'>
            <Card.Body>
                <Card.Title className='industrial-modeling-title'> バーチャル（VR）ワールド（別名：メタバース） </Card.Title>
                <Card.Text className='industrial-environment-text text-left'>
                コンシューマー向けVRの黎明期と2016年のパラコズマの設立から、私たちはマルチユーザー向けバーチャルワールドの作成と利用を実験的に行ってきました。Altspace VRからVR Chat、FortniteからRoblox、Engage VRからEON Realityまで、ほぼすべてのプラットフォームで実験、探求、開発をしてきました。 
                <br /><br /> 
                パンデミック発生当初は、すぐに社内の会議、プレゼンテーション、イベント用に自社のバーチャルオフィスと講堂を作り、他のバーチャルカンファレンスと組み合わせて、バーチャルオフィスでのネットワーキングイベントを数多く開催してきました。
                </Card.Text>
                
            </Card.Body>
            <Row className='pt-md-5'>
                <Col xs={{span:12, offset:0}} md={{span:5, offset:0}}>
                    <Card.Title className='vr-healthcare-title'> パラコズマのバーチャルオフィス </Card.Title>
                    <Card.Text className='text-left vr-healthcare-text'>
                    パラコズマのバーチャルオフィスは、会議室やオーディトリアム、そしてサンフランシスコの素晴らしい景色を備えています。
                    </Card.Text>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:7, offset:0}}>
                    <Card className='no-border rounded-0 container healthcare-video-container product-video-section' onClick={() => openVideoModal('/assets/vr-development/paracosma-office/po_001.mp4')}>
                        <Card.Img className='img img-thumbnail' src={"/assets/vr-development/paracosma-office/images/paracosma-office-banner.jpg"} />
                        <Card.ImgOverlay className='playicon-overlay-center'>
                            <Card.Img src={"/assets/icons/video-player.png"} />
                        </Card.ImgOverlay>
                    </Card>
                </Col>
            </Row>
        </Card>

        <div className="paracosma-slideshow d-none d-md-block">
            <div className="paracosma-image-mover"></div>
        </div>

        <div className="paracosma-mobile-slideshow d-sm-block d-md-none">
            <div className="paracosma-mobile-image-mover"></div>
        </div>

        <Card className='no-border rounded-0 virtual-world-container'>
            <Card.Body>
                <Card.Title className='virtual-world-gallery-title'> バーチャルワールドとバーチャルイベントのビデオギャラリー </Card.Title>
            </Card.Body>
            <Row className='pt-md-2'>
                <Col xs={{span:12, offset:0}} md={{span:4, offset:2}} className="no-padding-x pb-md-5">
                    <Card className='no-border rounded-0 container healthcare-video-container product-video-section' onClick={() => openVideoModal('/assets/vr-development/virtual-world-gallery/videos/vwg_004.mp4')}>
                        <Card.Img className='img img-thumbnail' src={"/assets/vr-development/virtual-world-gallery/images/vwg_004.jpg"} />
                        <Card.ImgOverlay className='playicon-overlay-center'>
                            <Card.Img src={"/assets/icons/video-player.png"} />
                        </Card.ImgOverlay>
                        <Card.Title className='vr-worlds-footer-title'> 4K・VR徳島映画祭 </Card.Title>
                    </Card>
                </Col>

                <Col xs={{span:12, offset:0}} md={{span:4, offset:0}} className="no-padding-x pb-md-5">
                    <Card className='no-border rounded-0 container healthcare-video-container product-video-section' onClick={() => openVideoModal('/assets/vr-development/virtual-world-gallery/videos/vwg_001.mp4')}>
                        <Card.Img className='img img-thumbnail' src={"/assets/vr-development/virtual-world-gallery/images/vwg_001.jpg"} />
                        <Card.ImgOverlay className='playicon-overlay-center'>
                            <Card.Img src={"/assets/icons/video-player.png"} />
                        </Card.ImgOverlay>
                        <Card.Title className='vr-worlds-footer-title'> ロイズ社のバーチャルオフィス </Card.Title>
                    </Card>
                </Col>

                <Col xs={{span:12, offset:0}} md={{span:4, offset:2}} className="no-padding-x pb-md-5">
                    <Card className='no-border rounded-0 container healthcare-video-container product-video-section' onClick={() => openVideoModal('/assets/vr-development/virtual-world-gallery/videos/vwg_002.mp4')}>
                        <Card.Img className='img img-thumbnail' src={"/assets/vr-development/virtual-world-gallery/images/vwg_002.jpg"} />
                        <Card.ImgOverlay className='playicon-overlay-center'>
                            <Card.Img src={"/assets/icons/video-player.png"} />
                        </Card.ImgOverlay>
                        <Card.Title className='vr-worlds-footer-title'> アマゾンのVRストア </Card.Title>
                    </Card>
                </Col>

                <Col xs={{span:12, offset:0}} md={{span:4, offset:0}} className="no-padding-x pb-md-5">
                    <Card className='no-border rounded-0 container healthcare-video-container product-video-section' onClick={() => openVideoModal('/assets/vr-development/virtual-world-gallery/videos/vwg_003.mp4')}>
                        <Card.Img className='img img-thumbnail' src={"/assets/vr-development/virtual-world-gallery/images/vwg_003.jpg"} />
                        <Card.ImgOverlay className='playicon-overlay-center'>
                            <Card.Img src={"/assets/icons/video-player.png"} />
                        </Card.ImgOverlay>
                        <Card.Title className='vr-worlds-footer-title'> パシュパティナート寺院（Pashupatinath Temple）</Card.Title>
                    </Card>
                </Col>

            </Row>
        </Card>

        <VideoPlayerModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        videosrc={videoUrl}
        />
    </>
  )
}

export default VirtualWorlds
